import { render } from "./DesktopSetting.vue?vue&type=template&id=69835c8e&scoped=true"
import script from "./DesktopSetting.vue?vue&type=script&lang=js"
export * from "./DesktopSetting.vue?vue&type=script&lang=js"

import "./DesktopSetting.vue?vue&type=style&index=0&id=69835c8e&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-69835c8e"]])

export default __exports__